import { combineReducers } from 'redux';

import { reducer as list } from './listModule';
import { reducer as setDefault } from './setDefaultModule';

export default combineReducers({
	list,
	setDefault,
});
